import { setCookie } from "@/lib/setCookie";
import { reset } from "@/redux/slices";
import { RootState } from "@/redux/store";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const useHeader = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false);
  const [isLogoutOpen, setIsLogoutOpen] = useState(false);
  const [openChangePassword, setOpenChangePassword] = useState<boolean>(false);

  const loggedInUserData = useSelector(
    (state: RootState) => state.currentData.loggedInUserData
  );

  useEffect(() => {
    if (loggedInUserData?.temp_pass) {
      setOpenChangePassword(true);
    }
  }, [loggedInUserData]);

  const handleClose = () => setIsOpen(false);

  const onLogoutClick = () => {
    setIsLogoutOpen(true);
  };

  const onLogout = () => {
    dispatch(reset());
    setCookie("accessToken", "");
    navigate(`/`);
  };

  const onChangePassword = () => {
    setOpenChangePassword(true);
  };

  return {
    isOpen,
    onLogoutClick,
    handleClose,
    setIsOpen,
    loggedInUserData,
    isLogoutOpen,
    setIsLogoutOpen,
    onLogout,
    isProfileMenuOpen,
    setIsProfileMenuOpen,
    onChangePassword,
    openChangePassword,
    setOpenChangePassword
  };
};

export default useHeader;
